import * as React from 'react';
import classNames from 'classnames';
import SvgSprite from 'src/react/components/html-elements/SvgSprite';
import { AvatarBadge } from 'ui/avatar/AvatarBadge';
import { TextColor } from '@collaborator/npm_modules/dist/css/text-color';
import { BGColor } from '@collaborator/npm_modules/dist/css/bg-color';
import { forwardRef } from 'react';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
var Avatar = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var image = _ref.image,
      icon = _ref.icon,
      textColor = _ref.textColor,
      bgColor = _ref.bgColor,
      _ref$badge = _ref.badge,
      badge = _ref$badge === void 0 ? {} : _ref$badge,
      sizeXxs = _ref.sizeXxs,
      sizeXs = _ref.sizeXs,
      sizeSm = _ref.sizeSm,
      sizeLg = _ref.sizeLg,
      sizeXl = _ref.sizeXl,
      bordered = _ref.bordered,
      borderGreen = _ref.borderGreen,
      additionalClassName = _ref.additionalClassName,
      popoverProps = _ref.popoverProps;
  var iconTextColorDefault = TextColor.textPale;
  var iconBGColorDefault = BGColor.light;
  var iconSizeDefault = 24;

  var renderContent = function renderContent() {
    if (icon) {
      var id = icon.id,
          _icon$size = icon.size,
          size = _icon$size === void 0 ? iconSizeDefault : _icon$size;
      return /*#__PURE__*/React.createElement(SvgSprite, {
        id: id,
        size: size
      });
    }

    return /*#__PURE__*/React.createElement("img", {
      src: image,
      className: "avatar-img"
    });
  };

  var wrapPopover = function wrapPopover(component) {
    if (!popoverProps) {
      return component;
    }

    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement(PopoverStickOnHover, popoverProps, component)
    );
  };

  var component = /*#__PURE__*/React.createElement("div", {
    className: classNames('avatar', {
      'avatar-with-icon': icon
    }, icon ? textColor || iconTextColorDefault : null, icon ? bgColor || iconBGColorDefault : null, {
      'avatar-xxs': sizeXxs
    }, {
      'avatar-xs': sizeXs
    }, {
      'avatar-sm': sizeSm
    }, {
      'avatar-lg': sizeLg
    }, {
      'avatar-xl': sizeXl
    }, {
      'avatar-bordered': bordered
    }, {
      'avatar-border-green': borderGreen
    }, additionalClassName),
    ref: forwardedRef
  }, renderContent(), /*#__PURE__*/React.createElement(AvatarBadge, {
    icon: badge.icon,
    text: badge.text,
    style: badge.style
  }));
  return wrapPopover(component);
});
export { Avatar };